import $ from "jquery";
export default class CountDownTimer {
    constructor($container) {
        this.$container = $container;
        this.$daysNode = $(".days", $container);
        this.$hoursNode = $(".hours", $container);
        this.$minutesNode = $(".minutes", $container);
        this.$secondsNode = $(".seconds", $container);
        const targetDateStr = $container.data("targetdate");
        this.targetDate = Date.parse(targetDateStr);
        if (!this.isTargetDatePassed()) {
            this.update();
            this.startUpdate();
        }
    }
    isTargetDatePassed() {
        const now = new Date().getTime(), distance = this.targetDate - now;
        return distance <= 0;
    }
    static mount(selector = ".ce-countdown") {
        const elements = $(selector);
        elements.each(function () {
            new CountDownTimer($(this));
        });
    }
    startUpdate() {
        setTimeout(() => { this.update(); }, 1000);
    }
    update() {
        const now = new Date().getTime(), distance = this.targetDate - now;
        const second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
        this.$daysNode.html(Math.floor(distance / (day)).toString());
        this.$hoursNode.html(Math.floor((distance % (day)) / (hour)).toString());
        this.$minutesNode.html(Math.floor((distance % (hour)) / (minute)).toString());
        this.$secondsNode.html(Math.floor((distance % (minute)) / second).toString());
        if (this.isTargetDatePassed()) {
            this.$daysNode.html("0");
            this.$hoursNode.html("0");
            this.$minutesNode.html("0");
            this.$secondsNode.html("0");
            location.reload();
        }
        else {
            setTimeout(() => { this.update(); }, 1000);
        }
    }
}
